const PurchaseOrderTypes = {
  GET_PURCHASE_ORDER_LIST_PROGRESS: 'PO_TYPE.GET_PURCHASE_ORDER_LIST_PROGRESS',
  GET_PURCHASE_ORDER_LIST_SUCCESS: 'PO_TYPE.GET_PURCHASE_ORDER_LIST_SUCCESS',
  GET_PURCHASE_ORDER_LIST_ERROR: 'PO_TYPE.GET_PURCHASE_ORDER_LIST_ERROR',
  SET_PURCHASE_ORDER_LIST: 'PO_TYPE.SET_PURCHASE_ORDER_LIST',
  SET_PURCHASE_ORDER_FILTERS: 'PO_TYPE.SET_PURCHASE_ORDER_FILTERS',
  SET_PURCHASE_ORDER_SELECTED_DATA: 'PO_TYPE.SET_PURCHASE_ORDER_SELECTED_DATA',
  SET_PURCHASE_ORDER_SIDEBAR_TOGGLE: 'PO_TYPE.SET_PURCHASE_ORDER_SIDEBAR_TOGGLE',
  GET_PURCHASE_ORDER_INFO_PROGRESS: 'PO_TYPE.GET_PURCHASE_ORDER_INFO_PROGRESS',
  GET_PURCHASE_ORDER_INFO_SUCCESS: 'PO_TYPE.GET_PURCHASE_ORDER_INFO_SUCCESS',
  GET_PURCHASE_ORDER_INFO_ERROR: 'PO_TYPE.GET_PURCHASE_ORDER_INFO_ERROR',
  SET_PURCHASE_ORDER_INFO: 'PO_TYPE.SET_PURCHASE_ORDER_INFO',
  SET_PURCHASE_ORDER_EXPORT_TOGGLE: 'PO_TYPE.SET_PURCHASE_ORDER_EXPORT_TOGGLE',
  SET_DRAFT_ORDER_SEARCH_EXPORT_TOGGLE: 'PO_TYPE.SET_DRAFT_ORDER_SEARCH_EXPORT_TOGGLE',
  SET_REGULAR_ORDER_SELECTED_DATA: 'PO_TYPE.SET_REGULAR_ORDER_SELECTED_DATA',
  SET_RELEASE_ORDER_DATA: 'PO_TYPE.SET_RELEASE_ORDER_DATA',
  SET_PURCHASE_ORDER_SHIPMENT: 'PO_TYPE.SET_PURCHASE_ORDER_SHIPMENT',
  SET_SELECT_ALL_CHECK: 'PO_TYPE.SET_SELECT_ALL_CHECK',
  PO_IS_CARD_VIEW: 'PO_TYPE.PO_IS_CARD_VIEW',
  SET_TOTAL_PO_RECORDS: 'PO_TYPE.SET_TOTAL_PO_RECORDS',
  SET_PACKING_LIST_DATA: 'PO_TYPE.SET_PACKING_LIST_DATA',
  PO_TMS_SETTINGS: 'PO_TYPE.PO_TMS_SETTINGS',
};

export default PurchaseOrderTypes;
